import * as React from 'react';

export const BkashIcon = ({ ...props }) => {
  return (
    <svg
      className="w-18 h-8"
      viewBox="0 0 868 410"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M774.679 223.842L594.225 195.564L618.147 303.095L774.679 223.842Z"
        fill="#D12053"
      />
      <path
        d="M774.678 223.844L638.699 34.916L594.258 195.6L774.678 223.844Z"
        fill="#E2136E"
      />
      <path
        d="M590.039 193.422L447.561 11.334L634.14 33.6228L590.039 193.422Z"
        fill="#D12053"
      />
      <path
        d="M525.146 117.332L446.029 42.7754H466.855L525.146 117.332Z"
        fill="#9E1638"
      />
      <path
        d="M813.167 132L779.682 222.823L725.406 147.755L813.167 132Z"
        fill="#D12053"
      />
      <path
        d="M639.211 297.653L770.596 244.874L776.109 228.098L639.211 297.653Z"
        fill="#E2136E"
      />
      <path
        d="M534.129 397.253L590.413 199.818L618.963 328.277L534.129 397.253Z"
        fill="#9E1638"
      />
      <path
        d="M818.406 132.715L804.59 170.215L854.408 169.398L818.406 132.715Z"
        fill="#E2136E"
      />
      <path
        d="M13.625 147.754C16.041 147.958 18.4911 148.4 21.0773 148.4C23.6635 148.4 25.7733 147.958 28.5296 147.754V227.619C36.3903 214.246 46.2926 205.433 60.857 205.433C87.1953 205.433 98.4928 231.499 98.4928 255.455C98.4928 284.141 83.1799 311.603 56.3311 311.603C50.9556 311.721 45.6503 310.366 40.9897 307.684C36.3292 305.003 32.4909 301.098 29.8908 296.392C25.399 300.339 21.4176 305.069 17.164 309.357H13.7611L13.625 147.754ZM28.1893 265.221C28.1893 288.497 38.0577 304.729 54.2894 304.729C75.3532 304.729 82.125 276.417 82.125 256.34C82.125 233.03 74.4345 214.689 56.195 214.484C34.893 214.314 28.1893 239.53 28.1893 265.255"
        fill="#E2136E"
      />
      <path
        d="M167.198 199.411L151.34 219.829C166.245 241.607 181.694 262.943 196.666 284.994L211.775 308.814V310.005C208.066 309.767 204.697 309.29 201.567 309.29C198.436 309.29 194.489 309.767 191.154 310.005C187.036 302.382 182.953 295.338 178.291 288.431L137.456 228.029C136.538 227.077 134.326 226.328 134.326 227.315V310.005C131.331 309.767 128.711 309.29 126.125 309.29C123.539 309.29 120.544 309.767 117.924 310.005V147.756C120.544 147.96 123.368 148.47 126.125 148.47C128.881 148.47 131.331 147.96 134.326 147.756V220.986C134.326 222.415 137.116 221.462 138.954 219.556C142.498 215.882 145.816 211.995 148.89 207.918L194.795 147.688C197.211 147.892 199.627 148.402 202.247 148.402C204.867 148.402 206.875 147.892 209.529 147.688L167.198 199.411Z"
        fill="#231F20"
      />
      <path
        d="M290.689 291.731C290.689 300.17 290.144 304.457 301.135 301.667V306.397C299.34 307.297 297.459 308.015 295.521 308.541C285.822 310.48 277.792 308.745 276.294 296.052L274.627 297.924C271.385 302.172 267.203 305.612 262.409 307.973C257.615 310.335 252.34 311.554 246.996 311.535C233.792 311.535 222.223 301.123 222.223 285.163C222.223 260.56 239.237 257.327 256.694 254.095C271.462 251.304 276.499 250.011 276.499 239.633C276.499 223.639 268.672 214.383 254.686 214.383C249.91 214.29 245.22 215.666 241.252 218.326C237.283 220.985 234.228 224.8 232.499 229.254H230.458V217.276C238.855 209.97 249.516 205.787 260.641 205.434C280.208 205.434 290.859 217.276 290.859 241.674L290.689 291.731ZM275.784 256.102L269.216 257.6C256.524 260.39 237.502 262.534 237.502 282.237C237.502 295.848 244.307 302.654 255.741 302.654C261.655 301.925 267.064 298.953 270.85 294.351C272.211 292.786 275.954 289.11 275.954 287.545L275.784 256.102Z"
        fill="#231F20"
      />
      <path
        d="M323.934 288.871C328.358 297.345 336.593 304.933 345.372 304.933C350.382 304.677 355.095 302.481 358.513 298.809C361.93 295.138 363.783 290.279 363.68 285.264C363.68 256.136 319.612 275.056 319.612 237.352C319.612 216.662 333.224 205.467 350 205.467C357.418 205.302 364.732 207.236 371.098 211.047C369.26 216.04 367.782 221.157 366.674 226.36H364.973C362.523 219.248 356.023 212.102 349.115 212.102C339.791 212.102 332.101 218.398 332.101 230.07C332.101 257.667 376.168 242.967 376.168 277.506C376.168 300.611 358.269 311.535 341.799 311.535C333.551 311.528 325.476 309.167 318.523 304.729C320.194 299.552 321.501 294.264 322.437 288.905L323.934 288.871Z"
        fill="#231F20"
      />
      <path
        d="M401.281 147.754C403.765 147.958 406.181 148.4 408.768 148.4C411.354 148.4 413.464 147.958 416.254 147.754V226.326C422.787 213.157 433.03 205.433 446.301 205.433C467.944 205.433 476.349 220.269 476.349 247.492V310.003C473.524 309.765 471.347 309.357 468.862 309.357C466.378 309.357 463.826 309.799 461.376 310.003V252.426C461.376 228.606 456.578 216.594 440.687 216.594C423.876 216.594 416.254 228.708 416.254 251.133V310.003C413.464 309.765 411.252 309.357 408.768 309.357C406.283 309.357 403.799 309.799 401.281 310.003V147.754Z"
        fill="#231F20"
      />
    </svg>
  );
};
